"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var system_1 = require("@mui/system");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var AssertionHeading_1 = __importDefault(require("./styles/AssertionHeading"));
var StyledModal_1 = __importDefault(require("./styles/StyledModal"));
var ConfirmationModal = function (_a) {
    var heading = _a.heading, _b = _a.confirmText, confirmText = _b === void 0 ? 'Are you sure?' : _b, _c = _a.buttonType, buttonType = _c === void 0 ? 'neutral' : _c, _d = _a.buttonLabel, buttonLabel = _d === void 0 ? 'Yes' : _d, onClick = _a.onClick, onClose = _a.onClose, noCancel = _a.noCancel, props = __rest(_a, ["heading", "confirmText", "buttonType", "buttonLabel", "onClick", "onClose", "noCancel"]);
    return ((0, jsx_runtime_1.jsx)(StyledModal_1.default, __assign({}, props, { onClose: onClose }, { children: (0, jsx_runtime_1.jsxs)(system_1.Box, __assign({ px: 4, py: 3 }, { children: [(0, jsx_runtime_1.jsx)(AssertionHeading_1.default, { children: heading }), confirmText && (0, jsx_runtime_1.jsx)(system_1.Box, __assign({ pt: 1.25 }, { children: (0, jsx_runtime_1.jsx)(AssertionHeading_1.default, { children: confirmText }) })), (0, jsx_runtime_1.jsxs)(system_1.Box, __assign({ display: "flex", justifyContent: "space-between", pt: 1 }, { children: [!noCancel && ((0, jsx_runtime_1.jsx)(system_1.Box, __assign({ mr: 2, flex: 1 }, { children: (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", fullWidth: true, onClick: onClose }, { children: "Cancel" })) }))), (0, jsx_runtime_1.jsx)(system_1.Box, __assign({ flex: 1 }, { children: (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: buttonType, fullWidth: true, onClick: onClick }, { children: buttonLabel })) }))] }))] })) })));
};
exports.default = ConfirmationModal;
